import { useFormik } from "formik";
import * as Yup from "yup";
import ModalInfo from "../../../components/lib/modalInfo";
import { RiErrorWarningLine } from "react-icons/ri";
import { GrCircleQuestion } from "react-icons/gr";

const EmployeeRegisterForm = ({ onSubmit, onDirty = () => { } }) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone_number: '',
            emergency_value: 0.0,
            spend_limit: 0.0,
        },
        validationSchema: Yup.object({
            name: Yup.string().required('O campo nome é obrigatório.')
                .max(50, 'O nome deve ter no máximo 50 caracteres')
                .trim('O campo não deve conter espaços no início ou fim')
                .test(
                    "two-words",
                    "O nome deve ser completo, formado por mais de uma palavra.",
                    (value) => value && value.trim().split(/\s+/).length >= 2
                ),
            email: Yup.string()
                .email("Email inválido").required("Email obrigatório")
                .max(240, 'O email deve ter no máximo 240 caracteres')
                .trim('O campo não deve conter espaços no início ou fim'),
            phone_number: Yup.string()
                .max(11, 'O telefone deve ter no máximo 11 caracteres'),
        }),
        onSubmit: (values) => {
            onSubmit({
                ...values,
                role: "EMPLOYEE",
                login_code: sessionStorage.getItem("loginCode"),
                clientCode: sessionStorage.getItem("clientCode"),
                user_status: true,
            });
        },
    });

    const handleChange = (e) => {
        onDirty();
        formik.handleChange(e);
    };

    return (
        <form
            data-step-form
            onSubmit={formik.handleSubmit}
            className="flex flex-col gap-4"
            onChange={onDirty}
        >
            <label>
                <div className="flex relative items-center justify-between">
                    <p>Nome</p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.name && formik.errors.name ? 'border-red-500' : ''
                        }`}
                    name="name"
                    type="text"
                    onChange={handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.name}</p>
                )}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    <p>Email</p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.barcode && formik.errors.barcode ? 'border-red-500' : ''
                        }`}
                    name="email"
                    type="text"
                    onChange={handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.email}</p>
                )}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    <p>Telefone</p>
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.phone_number && formik.errors.phone_number ? 'border-red-500' : ''
                        }`}
                    name="phone_number"
                    type="text"
                    onChange={handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.phone_number}
                />
                {formik.touched.phone_number && formik.errors.phone_number && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.phone_number}</p>
                )}
            </label>

            <div className="grid grid-cols-2 gap-x-4 my-8">
                    <label>
                        <div className="flex items-center justify-between">
                            <p>Valor de Emergência</p>
                            <ModalInfo icon={<GrCircleQuestion />} content="O valor de Emergência é o valor negativo que o aluno pode alcançar ficando em débito com a cantina. Pode ser alterado também pelos responsáveis entre o intervalo de 0 ao valor máximo estabelecido pelos administradores da cantina." />
                        </div>
                        <input className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            name="emergency_value"
                            type="number"
                            step="0.05"
                            min="0.0"
                            onChange={formik.handleChange} onBlur={formik.handleBlur}
                            value={formik.values.emergency_value} />
                    </label>
                    <label>
                        <div className="flex items-center justify-between">
                            <p>Limite de gastos diário</p>
                            <ModalInfo icon={<GrCircleQuestion />} content="O limite de gastos diário é o valor em pedidos que o aluno pode realizar por dia. Pode ser alterado também pelos responsáveis." />
                        </div>
                        <input className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none disabled:opacity-50"
                            name="spend_limit"
                            type="number"
                            step="0.05"
                            min="0.0"
                            onChange={formik.handleChange} onBlur={formik.handleBlur}
                            value={formik.values.spend_limit} />
                    </label>
                </div>
        </form>
    );
};

export default EmployeeRegisterForm;
